__turbopack_context__.v({
  "container": "BVFG1W_container",
  "orb": "BVFG1W_orb",
  "orbBottomRight": "BVFG1W_orbBottomRight",
  "orbTopLeft": "BVFG1W_orbTopLeft",
  "orbitWrapper": "BVFG1W_orbitWrapper",
});
